import React from "react";
import c from "./IntroPg.module.css";
import {BiCheckCircle} from 'react-icons/bi'

const IntroPg = (props) => {
  return (
    <section
      className={`page ${c.sec}`}
      id="home"
      onClick={() => {
        props.toggleContact();
      }}
    >
      <div>
        <h1>Happy New Year</h1>
        <p>My name is 
          <em className={c.name}><br/>Paul Christian</em>.</p>
        <p>
          A front-end developer based in the <em>Philippines</em>.
        </p>
      </div>
      <div>
        
        <p>From Youtube to W3schools to freeCodeCamp, I used various resources online to train in web development. <br/>You could say I'm an expert Googler!</p>
        <p>When developing, I create checklists of things. Like this:</p>
        <ul className={c.ul}>
          <strong>My Qualities</strong>
          <li><BiCheckCircle />Proactiveness</li>
          <li><BiCheckCircle />Good sense of design</li>
          <li><BiCheckCircle />Strong collaboration</li>
          <li><BiCheckCircle />Good listener</li>
          
        </ul>
        <p>Explore my sites!</p>
      </div>
    </section>
  );
};

export default IntroPg;
